// Starting the coach for an onboarded athlete who confirms 18+ only now (the
// "We've updated our terms" modal, consent/TermsModal.jsx): without the
// confirmation the coach built them nothing (D58; Sam, 2026-10-24: ~50
// onboarded athletes were never asked). POST /v2/onboarding/complete starts
// the coach's intake questions and then a strategy proposal in the thread;
// their current plan stays on the calendar until they accept. It replaces the
// cutover's "Your coach has moved" sheet, which asked the same.

import { actions, call } from './actions';

/**
 * POST /v2/onboarding/complete {confirm_adult: true} with `key` (kept across
 * retries), then `onDone` and the coach thread opens (`chat:open`). Throws
 * CommandRefused (its `detail` to show) or {network}.
 */
export async function getStarted(api, key, { onDone, win = globalThis.window } = {}) {
  const answer = await call(api, { ...actions.completeOnboarding(true), key });
  onDone?.(answer);
  win?.dispatchEvent?.(new CustomEvent('chat:open'));      // CoachThread is mounted beside the modal (Layout)
  return answer;
}
